const escapeCsvValue = (value) => {
  const str = value === null || value === undefined ? "" : String(value);
  if (/[",;\n]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
};

// Genera un CSV (se abre directo en Excel) y dispara su descarga en el navegador.
export const exportToCsv = (filename, headers, rows) => {
  const lines = [headers.map(escapeCsvValue).join(",")];
  rows.forEach((row) => {
    lines.push(row.map(escapeCsvValue).join(","));
  });

  // BOM al inicio para que Excel detecte UTF-8 y respete acentos/ñ.
  const csvContent = "﻿" + lines.join("\r\n");
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
